import { Link } from "react-router-dom";
import { FaChartSimple } from 'react-icons/fa6'
import { Card } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";


export default function MenuEstadisticas() {
    return <>
        <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Inicio</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>Estadísticas</Breadcrumb.Item>
        </Breadcrumb>
        <nav>
            <Row>
                {/* <Col sm="3" className="mb-2">
                    
                </Col> */}
                <Col sm="6" className="mb-2">
                    <Link to="/estadistica/ventas">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaChartSimple></FaChartSimple>
                                </Card.Title>
                                <Card.Text>Resultado de Ventas</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="6" className="mb-2">
                    <Link to="/estadistica/evolucion-ventas">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaChartSimple></FaChartSimple>
                                </Card.Title>
                                <Card.Text>Evolución de Ventas</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </nav>
    </>
}